import React from 'react';
import { inject, observer } from 'mobx-react';
import { observable } from 'mobx';
import FormMultiSelectInput from '../../../FormMultiSelectInput';

@inject('userStore', 'workOrderStore', 'rolePermissionStore')
@observer
export default class WorkOrderFollower extends React.Component {

  @observable addFollower = false;
  @observable multiUserOptions = [];

  componentDidMount() {
    const { userStore, workOrderStore } = this.props;

    if (userStore.items && userStore.items.length > 0) {
      if (this.multiUserOptions.length === 0) {
        const newMultiUserOptions = userStore.items.map(item => ({
          id: item.id,
          name: item.name,
          email: item.email,
          label: item.name + (!item.email ? '' : `(${item.email})`),
          value: !!workOrderStore.followers.find(follower => +follower.user_id === +item.id)
        }));

        this.multiUserOptions = newMultiUserOptions;
      }
    }
  }

  onToggleAddFollower = () => this.addFollower = !this.addFollower;

  onAddFollower = user => {
    const { workOrderStore, workOrder_id } = this.props;
    workOrderStore.addWorkOrderFollower(workOrder_id, user);
  };

  onRemoveFollower = user_id => {
    const { workOrderStore, workOrder_id } = this.props;
    workOrderStore.removeWorkOrderFollower(workOrder_id, user_id);
    this.multiUserOptions.find(item => +item.id === +user_id).value = false;
  };


  onUserSelect = (item) => {
    item.value = !item.value;

    if (item.value) {
      this.onAddFollower({
        user_id: item.id,
        name: item.name,
        email: item.email,
      });
    } else {
      this.onRemoveFollower(item.id);
    }

  }

  render() {
    const { workOrderStore, userStore, rolePermissionStore } = this.props;
    const hasUserPermission = rolePermissionStore.validateRole('view user');

    let availableFollowers = userStore.items.filter(user => workOrderStore.followers.map(follower => follower.user_id).indexOf(user.id) === -1);

    return (
      <div className='ticket-follower'>
        <div className='DataTable'>
          <table>
            <thead style={{ color: this.addFollower ? "black" : "white" }}>
              <tr>
                <th>{ }</th>
                <th>{this.addFollower ?
                  <FormMultiSelectInput id='user-multi-select' label='' options={this.multiUserOptions} optionClicked={item => this.onUserSelect(item)} loading={false} hideSelectAll hideClearAll /> :
                  `Followers (${workOrderStore.followers.length})`
                }</th>
                {hasUserPermission && <th className='crudActions'>
                  <a onClick={this.onToggleAddFollower}><i className={this.addFollower ? 'fa fa-remove' : 'fa fa-plus'} /></a>
                </th>}
              </tr>
            </thead>
            <tbody>{workOrderStore.followers.map(item => {
              return (
                <tr key={`user_${item.user_id}`}>
                  <td width="20"><input type='checkbox' checked={item.checked} onChange={() => item.checked = !item.checked} /></td>
                  <td title={item.email}>{item.name}</td>
                  {hasUserPermission && <td className='crudActions'>
                    <a onClick={() => this.onRemoveFollower(item.user_id)}><i className='fa fa-remove' /></a>
                  </td>}
                </tr>
              )
            })}</tbody>
          </table>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Maintenance/WorkOrder/Followers/WorkOrderFollower.js